var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-table-style" },
    [
      _c(
        "el-collapse",
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "单元格" } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.onMergeCellsChange },
                      model: {
                        value:
                          _vm.selectItem.styleConfig.commongConfig.mergeCells,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.selectItem.styleConfig.commongConfig,
                            "mergeCells",
                            $$v
                          )
                        },
                        expression:
                          "selectItem.styleConfig.commongConfig.mergeCells",
                      },
                    },
                    [_vm._v("合并同类单元格")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "chart-form-item-warp" },
                    [
                      _c("span", { staticClass: "jz-chart-title-label" }, [
                        _vm._v("分页器"),
                      ]),
                      _vm._v(" "),
                      _c("el-switch", {
                        model: {
                          value:
                            _vm.selectItem.styleConfig.commongConfig.pagination,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.selectItem.styleConfig.commongConfig,
                              "pagination",
                              $$v
                            )
                          },
                          expression:
                            "selectItem.styleConfig.commongConfig.pagination",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }